require('./openYoungCardDeleteChoresView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ actions
const openYoungCardChoreStatusUpdate = require('actions/openYoungCardChoreStatusUpdate');
const openYoungCardChores = require('actions/openYoungCardChores');

// @ components
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const DeleteChore = require('./components/DeleteChoreConfirmation');
const { OKCover } = require('commonsComponents/OKCover');

// @ Utilities
const { formatText, getFinalTitle } = require('core/i18n').i18n;

class DeleteChoresView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { match: { params: { choreAssignmentId } }, getChoreDetail } = this.props;
        getChoreDetail( choreAssignmentId );
    }

    componentWillUnmount() {
        this.props.openYoungChoreResetStatusUpdateInfo();
    }


    buildHeader() {
        const {
            immCards,
            match: { params: { cardId } }
        } = this.props;

        const immCard = immCards.get('byId').get(cardId);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias','current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('breadcrumb-openYoungChores'),
                url: `/myprofile/cards/${cardId}/chores`
            },
            {
                text: formatText('breadcrumb-openYoungDeleteChores')
            }
        ];

        return (
            <OKCover size="medium" section="transfers">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle('deleteChore-headerTitle')} />
            </OKCover>
        );
    }

    render() {
        const {
            immCards,
            openYoungCardChoreStatusUpdateInfo,
            openYoungCardChores,
            match,
            updateChoreStatus
        } = this.props;

        if(openYoungCardChores.get('getChoreDetailFetch')) {
            return <LoadingSection />;
        }else if(openYoungCardChores) {
            return (
                <section>
                    <div>
                        {this.buildHeader()}
                    </div>
                    <div className="delete-chore-view__content">
                        <div className="row">
                            <div className="col-xs-8 col-xs-offset-2">
                                <DeleteChore
                                    immCards={immCards}
                                    openYoungCardChores={openYoungCardChores}
                                    openYoungCardChoreStatusUpdateInfo={openYoungCardChoreStatusUpdateInfo}
                                    updateChoreStatus={updateChoreStatus}
                                    match={match}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    }
}

DeleteChoresView.propTypes = {
    getChoreDetail: PropTypes.func.isRequired,
    immCards: PropTypes.object,
    openYoungCardChoreStatusUpdateInfo: PropTypes.object,
    openYoungCardChores: PropTypes.object.isRequired,
    openYoungChoreResetStatusUpdateInfo: PropTypes.func.isRequired,
    match: PropTypes.object,
    updateChoreStatus: PropTypes.func.isRequired
};

module.exports.constructor = DeleteChoresView;
module.exports.DeleteChoresView = connect(
    state => ({
        immCards: state.cards,
        openYoungCardChores: state.openYoungCardChores,
        openYoungCardChoreStatusUpdateInfo: state.openYoungCardChoreStatusUpdateInfo
    }),
    {
        getChoreDetail: openYoungCardChores.getChoreDetail,
        openYoungChoreResetStatusUpdateInfo: openYoungCardChoreStatusUpdate.openYoungChoreResetStatusUpdateInfo,
        updateChoreStatus: openYoungCardChoreStatusUpdate.updateChoreStatus
    })(DeleteChoresView);
